import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=5ad6d4f0&scoped=true"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=5ad6d4f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6d4f0",
  null
  
)

export default component.exports